import React from "react";
import { Chip } from "@mui/joy";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postFetch } from "../../../../../../fetch/fetch";

//직원명부 공용 — 상수/타입/포맷터/칩/파일 열기. contractsettings.tsx 의 errorText 와 같은 규칙
export const API = "/dashboard/employeedirectory";
export const toastOptions: any = { position: "bottom-right", autoClose: 3000, hideProgressBar: true, theme: "colored" };
export const EXCLUDED_LOCATIONS = ["total", "songdo_free", "get50", "getL"];   //biostarenrolldevicesetting.tsx 와 동일

export const errorText = (result: any, fallback: string) => {
    if (result && result.message === "NOT_AUTHORIZED") return "권한이 없습니다 (todoistApiKey 필요)";
    if (result && result.detail) return `${fallback} (${result.detail})`;
    return result && result.message ? `${fallback} (${result.message})` : fallback;
};

export interface LatestDoc {
    id: number;
    documentId: string;
    status: string;
    roundNo: number;
    periodStart: string | null;
    periodEnd: string | null;
    sentAt: string | null;
    expiresAt: string | null;
    completedAt: string | null;
    canceledAt: string | null;
    remindCount: number;
    remindLog: { at: string; by: number; byName: string; extended: boolean }[];
    sentBy: number | null;
    sentByName: string;
    isTest: number;
}

//TODO 항목 기록 (서버 JSON_SET). value = true | "YYYY-MM-DD" | "O"/"X"
export interface Stamp {
    value: any;
    doneBy: number | null;
    doneByName: string | null;
    doneAt: string | null;
    userDeactivated?: boolean;
    canceledDocs?: number;
    fingerprintDeleted?: boolean;
}

export interface Position {
    id: number;
    userId: number;
    name: string;
    phoneNumber: string;
    isNow: number | null;
    branchKey: string;
    branchLabel: string;
    partId: number | null;
    partName: string;
    templateId: string | null;
    templateName: string;
    mappingStatus: { state: string; unmappedCount: number; fieldCount: number };
    startDate: string | null;
    endDate: string | null;
    employmentInsurance: string;
    memo: string;
    onboarding: { [key: string]: Stamp };      //3단계 신규직원 TODO 항목 (acquisitionInput/acquisitionDone: date, kakaoSent/kakaoRead: true)
    offboarding: { [key: string]: Stamp };     //퇴사직원 TODO 항목 (lossInput/lossDone, salarySettled/Transferred, severanceEligible O|X, severanceSettled/Transferred, released)
    sexOffender: { checkedAt: string; checkedBy: number; checkedByName: string } | null;   //사람 단위
    videoConsentDoc: { id: number; documentId: string; status: string; expired: boolean; sentAt: string | null; sentByName: string; remindCount: number } | null;
    firstCompletedAt: string | null;
    isManaged: number;                          //1 = 명부·TODO 관리 대상 (0 이면 숨김)
    isActive: number;
    isMultiple: boolean;
    workDuration: string;
    nextRoundNo: number;
    isFirst: boolean;
    residentNumber: string;
    bankName: string;
    bankAccount: string;
    accountHolder: string;
    idCard: { documentId: string; attachmentId: string } | null;
    bankbook: { documentId: string; attachmentId: string } | null;
    needsReview: number;
    reviewMemo: string | null;
    videoConsentStatus: "none" | "pending" | "agreed" | "disagreed";
    videoConsentDocumentId: string | null;
    badge: { type: "first" | "before" | "expired"; days: number | null } | null;
    contractState: "none" | "pending" | "completed" | "canceled";
    expired: boolean;
    lastCompleted: { periodEnd: string; count: number } | null;
    latestDoc: LatestDoc | null;
}

const pad = (n: number) => (n < 10 ? "0" + n : "" + n);

export const todayStr = () => {
    const d = new Date();
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

//"YYYY-MM-DD" 또는 "YYYY-MM-DD HH:mm:ss" / ISO → "MM-DD"
export const mmdd = (v: any) => {
    if (!v) return "";
    const s = String(v);
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(5, 10);
    const d = new Date(v);
    if (isNaN(d.getTime())) return s;
    return `${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const mmddHHmm = (v: any) => {
    if (!v) return "";
    const s = String(v);
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(s)) return `${s.slice(5, 10)} ${s.slice(11, 16)}`;
    const d = new Date(v);
    if (isNaN(d.getTime())) return s;
    return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const periodText = (s: any, e: any) => (s && e ? `${mmdd(s)} ~ ${mmdd(e)}` : "");

export const formatPhone = (v: any) => {
    const d = String(v || "").replace(/[^0-9]/g, "");
    if (d.length === 11) return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
    if (d.length === 10) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
    return String(v || "");
};

//재직 = 퇴사일이 없거나 미래 (YYYY-MM-DD 문자열 비교)
//재직 = 해제되지 않았고 (퇴사일이 없거나 미래). 직무해제된 줄은 명부 "퇴사" 필터로
export const isActivePosition = (p: Position, today: string) => p.isActive === 1 && (!p.endDate || p.endDate > today);

//===== 텍스트 (엑셀 export 는 renderCell 이 아니라 valueGetter 값을 내보냄) =====

export const badgeText = (b: Position["badge"]) => {
    if (!b) return "";
    if (b.type === "first") return "첫계약 전";
    if (b.type === "before") return `만료 ${b.days}일 전`;
    return `만료 경과 ${b.days}일`;
};

export const contractStateText = (p: Position) => {
    if (p.contractState === "none") return "미발송 (첫 계약)";
    if (p.contractState === "pending") return p.expired ? "미서명 (만료됨)" : "미서명";
    if (p.contractState === "completed") return `서명완료 ${p.latestDoc ? p.latestDoc.roundNo : ""}회차`;
    return "요청취소";
};

export const videoConsentText = (s: string) => {
    if (s === "pending") return "미제출";
    if (s === "agreed") return "동의";
    if (s === "disagreed") return "미동의";
    return "미발송";
};

//===== 칩 =====

const Sub = (props: { text: string }) => <span style={{ marginLeft: "6px", fontSize: "11px", color: "#6b7280" }}>{props.text}</span>;

export const renderBadgeChip = (b: Position["badge"]) => {
    if (!b) return <span style={{ color: "#9ca3af" }}>-</span>;
    if (b.type === "first") return <Chip size="sm" variant="soft" color="primary">첫계약 전</Chip>;
    if (b.type === "before") return <Chip size="sm" variant="soft" color={(b.days !== null && b.days <= 10) ? "warning" : "success"}>만료 {b.days}일 전</Chip>;
    return <Chip size="sm" variant="soft" color="danger">만료 경과 {b.days}일</Chip>;
};

export const renderContractStateChip = (p: Position) => {
    const round = p.latestDoc ? `${p.latestDoc.roundNo}회차` : "";
    if (p.contractState === "none") return <span><Chip size="sm" variant="soft" color="neutral">미발송</Chip><Sub text="첫 계약" /></span>;
    if (p.contractState === "pending") return <span><Chip size="sm" variant="soft" color="warning">미서명</Chip><Sub text={round} /></span>;
    if (p.contractState === "completed") return <span><Chip size="sm" variant="soft" color="success">서명완료</Chip><Sub text={round} /></span>;
    return <Chip size="sm" variant="soft" color="danger">요청취소</Chip>;
};

export const renderVideoConsentChip = (s: string) => {
    if (s === "pending") return <Chip size="sm" variant="soft" color="warning">미제출</Chip>;
    if (s === "agreed") return <Chip size="sm" variant="soft" color="success">동의</Chip>;
    if (s === "disagreed") return <Chip size="sm" variant="soft" color="danger">미동의</Chip>;
    return <Chip size="sm" variant="soft" color="neutral">미발송</Chip>;
};

//===== 파일 열기: 서버가 3분짜리 링크를 발급 → 새 창 =====
//await 뒤의 window.open 은 팝업 차단에 걸릴 수 있어 빈 창을 먼저 열고 URL 을 넣는다
export const openFileLink = async (body: { kind: "file" | "audit" | "attachment"; documentId: string; attachmentId?: string }) => {
    const win = window.open("", "_blank");
    try {
        const result: any = await postFetch(`${API}/files/link`, body);
        if (result.message === "success" && result.url) {
            if (win) {
                win.location.href = result.url;
            } else {
                window.open(result.url, "_blank");
            }
            return;
        }
        if (win) win.close();
        toast.error(errorText(result, "파일 링크를 만들지 못했습니다"), toastOptions);
    } catch (e) {
        console.log(e);
        if (win) win.close();
        toast.error("오류가 발생했습니다", toastOptions);
    }
};
